/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Col_DayInputs */

const en_admin_funnel_col_day = /** @type {(inputs: Admin_Funnel_Col_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Day`)
};

/**
* | output |
* | --- |
* | "Day" |
*
* @param {Admin_Funnel_Col_DayInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_col_day = /** @type {((inputs?: Admin_Funnel_Col_DayInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Col_DayInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_col_day(inputs)
});
export { admin_funnel_col_day as "admin.funnel.col.day" }